





























import ClickOutside from 'vue-click-outside'
import HeaderHeightMixin from 'library/mixins/header-height'

export default

	mixins: [ HeaderHeightMixin ]

	props: mobile: Boolean

	directives: {
		ClickOutside
	}

	data: ->
		searchOpen: false
		userNavOpen: false
		query: ''

	computed:
		searchClasses: -> 'open' if @searchOpen

		computedHeaderHeight: ->
			top: if @mobile then @mobileHeaderHeight else @headerHeight

	methods:
		toggleSearch: ->
			if !@searchOpen
				@userNavOpen = false
				@searchOpen = true
			else @searchOpen = false

		toggleUserNav: ->
			if !@userNavOpen
				@searchOpen = false
				@userNavOpen = true
			else @userNavOpen = false

		# hide all dropdowns
		hideDropdowns: ->
			@userNavOpen = false
			@searchOpen = false

		# Send search's to the collections/all page
		search: ->
			@$router.push "/search?query=#{@query}"
			@$gtm.push
				event: 'Search'
				searchTerm: @query

